import { NextPage } from "next";
import React from "react";
import algoliaClient from "~/components/search/utils/algoliaClient";
import getIndexName from "~/components/search/utils/getIndexName";
import VendorsPage from "~/src/components/home/pages/VendorsPage";

interface IVendorAlgoliaHit {
  objectID: string;
  _id: string;
  name: string;
  slug: string;
  logo: string;
  description: string;
  usersCanRequestContentTranslation: boolean;
}

interface IVendorsProps {
  // eslint-disable-next-line
  // @ts-ignore
  initialResults: algoliasearch.Response<IVendorAlgoliaHit>;
}

const Vendors: NextPage<IVendorsProps> = props => {
  return <VendorsPage {...props} />;
};

Vendors.getInitialProps = async () => {
  const index = algoliaClient.initIndex(getIndexName("companies"));
  const results = await index.search({
    hitsPerPage: 15,
  });

  return {
    initialResults: results,
  };
};

export default Vendors;
